import { Box } from '@mui/material';
import { keyframes } from '@mui/system';
import { Colors } from '../../../constants/theme';

const pulse = keyframes`
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
`;

export const PulsingDot = () => (
  <Box
    sx={{
      width: 10,
      height: 10,
      borderRadius: '50%',
      backgroundColor: Colors.light.green,
      flexShrink: 0,
      display: 'block',
      alignSelf: 'center',
      animation: `${pulse} 1.6s ease-in-out infinite`,
    }}
  />
);
